export enum WizardItemType {
	DYNAMIC = 'dynamic',
	ITEM = 'item',
	TEXT = 'text',
	RADIO_LIST = 'radio_list',
	SUBMIT_BUTTON = 'submitButton',
	V_STACK = 'vstack',
	H_STACK = 'hstack',
	CHECKBOX = 'checkbox',
	COLLAPSE = 'collapse',
	SEND_CONVERSATION_MESSAGE_CONSULTATION = 'sendConversationMessageConsultation',
	AGREEMENT_LIST = 'agreementList',
	CODE_INPUT = 'codeInput',
	SUBTITLE = 'subtitle',
	TITLE = 'title',
	DATE_PICKER = 'datepicker',
	TEXT_AREA = 'textArea',
	TEXT_AREA_2 = 'textarea',
	TEXT_FIELD = 'textField',
	TEXT_FIELD_2 = 'textfield',
	SELECT = 'select',
	GROUP_CHECKBOX = 'groupCheckbox',
	HR = 'hr',
	UPLOAD = 'upload',
	CREATE_QUESTIONNAIRE_SCHEDULE = 'createQuestionnaireSchedule',
	CREATE_CONVERSATION_CONSULTATIONS = 'createConversationConsultations',
	MARKDOWN = 'markdown',
	SEND_NOTIFICATION_FILE = 'sendNotificationFile',
	ALERT = 'alert',
	PLAN_EDUCATION_FILE = 'planEducationMaterials',
	BUTTON = 'button',
	PLACEHOLDER = 'placeholder',
	SEND_CONVERSATION_MESSAGE = 'sendConversationMessage',
	SEND_NOTIFICATION = 'sendNotification',
	CONDITION = 'condition',
	GENERATE_PDF = 'generatePdf',
	EMIT_EVENT_CURRENT = 'emitEventCurrent',
	TAB = 'tab',
	SPACE = 'space',
	MULTIPLIER = 'multiplier',
	QUESTIONNAIRE = 'questionnaire',
	CONTENT = 'content',
	APP_NEWS_BUTTON = 'appNewsButton',
	CONTAINER = 'container',
	EMIT_EVENT = 'emitEvent',
	FILE_UPLOADED = 'fileUploaded',
	MARK_AS_COMPLETED = 'markAsCompleted',
	TAB_CONTAINER = 'tabContainer',
	CAROUSEL = 'carousel',
	SET_WIZARD_STEP_NEXT = 'setWizardStepNext',
	SEND_NOTIFICATION_DOCUMENTATION_FILE = 'sendNotificationDocumentationFile',
	CHECKBOX_LIST = 'checkbox_list',
	DATE = 'date',
	WORKFLOW = 'workflow',
	SEND_NOTIFICATION_CONVERSATION = 'sendNotificationConversation',
	MULTI_UPLOAD = 'multiupload',
	CREATE_EVENT = 'createEvent',
	PATIENT_CONSENT_REQUEST = 'patient_consent_request',
	FIELD_OF_CARE_SUKL_SELECT = 'field_of_care_sukl_select',
	SEND_CONVERSATION_MESSAGE_CONSULTATIONS = 'sendConversationMessageConsultations',
	CASE_TYPE_REGULATION = 'case_type_regulation',
	MARK_CONVERSATION_AS_COMPLETED = 'markConversationAsCompleted',
	BMI = 'bmi',
	PERMISSIONS_BUTTON = 'permissionsButton',
	VZP_REIMBURSEMENT = 'vzp_reimbursement',
	SEND_EDUCATION_MATERIAL = 'sendEducationMaterial',
	CREATE_PRESCRIPTION = 'createPrescription',
	GROUP = 'group',
	DIAGNOSIS_CZECH = 'diagnosis_czech',
	SEND_NOTIFICATION_CONVERSATION_CONSULTATIONS = 'sendNotificationConversationConsultations',
	DISABLE_FORM = 'disableForm',
	CREATE_CONVERSATION = 'createConversation',
	COMPLETE_CONVERSATION = 'completeConversation',
	IMAGE = 'image',
	ATTACHMENT = 'attachment',
	REDIRECT = 'redirect',
	BROWSER = 'browser',
	ON_SUBMIT = 'onSubmit',
	FILE_PREVIEW_BUTTON = 'filePreviewButton',
	PATIENT_HEADER = 'patient_header',
	VIDEO = 'video',
	SEND_WEB_SOCKET_PATIENT = 'sendWebSocketPatient',
	SPACER = 'spacer',
	FAMILY_MEMBER_CARD = 'familyMemberCard',
	USER_RELATIONS = 'userRelations',
	IMAGE_CARD = 'imageCard',
}
